document.addEventListener("DOMContentLoaded", function () {
  const calcButton = document.getElementById("calcButton");

  document.getElementById("waxWeight").addEventListener("input", function () {
    document.getElementById("cautionMessage").innerText = "";
  });

  calcButton.addEventListener("click", function () {
    const metalType = document.getElementById("metalTypeSelector").value;
    let waxWeight = parseFloat(document.getElementById("waxWeight").value);

    const metals = {
      pt100: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT1000",
      }, // PT1000
      pt950h: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT950H",
      }, // PT950H
      pt900: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT900",
      }, // PT900
      k24: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 880,
        name: "K24",
      }, // K24
      k18yg: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K18YG64",
      }, // K18YG(6:4)
      k18pg: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K18PG28",
      }, // K18
      k18: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K1855",
      }, // K18
      k10yg: {
        specificGravity: 12,
        unitCastPrice: 110,
        baseCost: 770,
        name: "K10YG",
      }, // K10
      sv950: {
        specificGravity: 10,
        unitCastPrice: 90,
        baseCost: 440,
        name: "SV950",
      }, // SV950
      sv925: {
        specificGravity: 10,
        unitCastPrice: 90,
        baseCost: 440,
        name: "SV925",
      }, // SV925
    };

    if (isNaN(waxWeight)) {
      document.getElementById("cautionMessage").innerText =
        "WAX重量を入力してください";
      return;
    }

    let selectedMetal = metals[metalType];
    let castWeight = waxWeight * selectedMetal.specificGravity;
    let totalCost = castWeight * selectedMetal.unitCastPrice;

    if (totalCost < selectedMetal.baseCost) {
      totalCost = selectedMetal.baseCost;
    }
    let priceElement = document.querySelector(
      `#${selectedMetal.name} td:nth-child(2)`,
    );
    let metalPrice = parseFloat(
      priceElement.innerText.replace("円/g", "").replace(",", ""),
    );

    if (isNaN(metalPrice)) {
      document.getElementById("cautionMessage").innerText =
        "地金の価格取得に失敗しました。";
      return;
    }

    let tax = 1.1;
    let metalCost = castWeight * metalPrice;
    let totalMetalCost = Math.round(metalCost / 0.86 * tax); // 地金代（税込）
    let grandTotalCost = totalCost + totalMetalCost; // 合計金額（税込）

    document.querySelector("#result span#castWeight").innerText =
      castWeight.toFixed(1);
    document.querySelector("#result span#unitCastPrice").innerText =
      selectedMetal.unitCastPrice;
    if (totalCost <= selectedMetal.baseCost) {
      document.querySelector("#result span#totalCost").innerText =
        `(*最低工賃になります) ${selectedMetal.baseCost}`;
    } else {
      document.querySelector("#result span#totalCost").innerText =
        totalCost.toLocaleString("ja-JP", {
          style: "decimal",
          currency: "JPY",
        });
    }
    document.querySelector("#result span#metalCost").innerText =
      totalMetalCost.toLocaleString("ja-JP", {
        style: "decimal",
        currency: "JPY",
      });
    document.querySelector("#result span#grandTotalCost").innerText =
      grandTotalCost.toLocaleString("ja-JP", {
        style: "decimal",
        currency: "JPY",
      });
  });
});
